/*
  Mantém a classe is-empty da gaveta coerente com o que está dentro dela.

  O defeito que isto conserta
  ---------------------------------------------------------------------------
  O primeiro "adicionar ao carrinho" de uma visita abria a gaveta em branco:
  sem cabeçalho, sem o produto, sem subtotal e sem o botão de finalizar. Só
  um painel branco.

  Por quê: quando a página carrega com o carrinho vazio, o servidor escreve
  <cart-drawer class="drawer is-empty ...">. No clique de adicionar, o
  bv-cart-adapter troca apenas o innerHTML da gaveta pelo HTML novo vindo da
  Section Rendering API e não copia as classes do elemento (só o caminho de
  redesenhar, usado no + / - / remover e no clique do ícone, copia). A classe
  is-empty então sobrevive com o carrinho já cheio, e o CSS do tema de
  referência faz o resto:

      cart-drawer.is-empty .drawer__header,
      cart-drawer.is-empty .cart-drawer__body,
      cart-drawer.is-empty .drawer__footer { height: 0; padding: 0; overflow: hidden; }

  Ou seja, as três faixas que formam a gaveta inteira colapsam para altura zero.
  Fechar e reabrir pelo ícone consertava sozinho, porque aí o adaptador copia as
  classes, o que explica o defeito só aparecer no primeiro item.

  A correção
  ---------------------------------------------------------------------------
  Em vez de depender de quem escreveu a classe, ela é derivada do conteúdo, que
  vem sempre fresco dentro do innerHTML trocado: o bloco .drawer__inner-empty só
  é renderizado com o carrinho vazio, e .cart-item só existe com itens.
  Feito num arquivo à parte para valer também se o adaptador mudar.
*/
(function () {
  if (window.__dlCartState) return;
  window.__dlCartState = true;

  function vazia(gaveta) {
    if (gaveta.querySelector('.drawer__inner-empty')) return true;
    return !gaveta.querySelector('.cart-item');
  }

  function sincroniza() {
    var lista = document.querySelectorAll('cart-drawer');
    for (var i = 0; i < lista.length; i++) {
      var gaveta = lista[i];
      var precisa = vazia(gaveta);
      // mexer só quando diverge: escrever classe à toa acorda outros observadores
      if (precisa !== gaveta.classList.contains('is-empty')) {
        if (precisa) gaveta.classList.add('is-empty');
        else gaveta.classList.remove('is-empty');
      }
    }
  }

  var agendado = false;
  function agenda() {
    if (agendado) return;
    agendado = true;
    var roda = function () {
      agendado = false;
      sincroniza();
    };
    if (window.requestAnimationFrame) window.requestAnimationFrame(roda);
    else setTimeout(roda, 16);
  }

  function iniciar() {
    sincroniza();
    // toda alteração do carrinho chega como troca de innerHTML da gaveta, que é
    // uma mutação de childList; o toggle de classe daqui não realimenta o laço
    if (window.MutationObserver && document.body) {
      new MutationObserver(agenda).observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('pageshow', sincroniza);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
